import { FinancialTabContent } from "@/components/patients/FinancialTabContent";
import { useFinancialSummary } from "@/hooks/useFinancialSummary";
import { useTranslation } from "react-i18next";

interface PatientFinancialTabProps {
  petId: string;
}

export function PatientFinancialTab({ petId }: PatientFinancialTabProps) {
  const { t } = useTranslation("patients");
  const { data, isLoading, error } = useFinancialSummary({ scope: "patient", petId });

  return (
    <FinancialTabContent
      summary={data?.summary}
      openAppointments={data?.openAppointments}
      paymentHistory={data?.paymentHistory}
      sales={data?.sales}
      openReceivables={data?.openReceivables}
      isLoading={isLoading}
      error={error}
      emptyMessage={t("financialTab.empty.patient")}
    />
  );
}
